'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  FRIENDS_QUERY_KEY,
  FRIENDS_TAB_COUNTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { removeFriend } from '@/utils/actions/players/friends/removeFriend';

export interface UseUnfriendParams {
  uuid: string;
  friendUuid: string;
}

export const useUnfriend = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, friendUuid }: UseUnfriendParams) => {
      const res = await removeFriend({ uuid, friendUuid });
      if (res.error) {
        throw new Error(`Failed to remove friend: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRIENDS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
